import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideoOn: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video-on, cam-on"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.75C2 5.67893 3.67893 4 5.75 4H13.25C15.2325 4 16.8557 5.53841 16.9909 7.48656L19.4066 6.15789C20.5729 5.51643 22 6.36022 22 7.69127V16.3087C22 17.6398 20.5729 18.4836 19.4066 17.8421L16.9909 16.5134C16.8557 18.4616 15.2325 20 13.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75ZM9.5 15C11.1569 15 12.5 13.6569 12.5 12C12.5 10.3431 11.1569 9 9.5 9C7.84315 9 6.5 10.3431 6.5 12C6.5 13.6569 7.84315 15 9.5 15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVideoOn;
